import { icon_arrow_right } from '@gn-audio/icons';

import { getSharedLink, getTitle } from '../../../getters';
import { TitledSitecoreItem } from '../../../types';
import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { MajorLink } from '../MegaMenuTypes';

export const MobileMajorSublink = ({
  sublink,
  isLast,
  handleNavigation,
}: {
  sublink: TitledSitecoreItem<MajorLink>;
  isLast: boolean;
  handleNavigation: (link: TitledSitecoreItem<MajorLink>) => void;
}) => {
  const linkField = getSharedLink(sublink.fields, 'Link');
  const title = getTitle(sublink) || sublink.displayName;

  if (!linkField) {
    return null;
  }
  return (
    <li
      tabIndex={0}
      role="link"
      onClick={() => handleNavigation(sublink)}
      className="flex cursor-pointer flex-col"
      key={sublink.id}
    >
      <span className="mb-2.5 flex h-full w-full items-center justify-between pt-2.5">
        <span>{title}</span>
        <JabraIcon className="h-4" Icon={icon_arrow_right} />
      </span>
      {!isLast && <hr className="border-b-1 border-slate-tint80" />}
    </li>
  );
};
